import { List, Typography } from "antd";
import type { IAcquirerOnboardingFlag } from "../../../../interfaces/businessFull.interface";
import type { FlagPersonRef } from "./onboardingFlagAttribution.helpers";
import {
  getOnboardingFlagTypeLabel,
  groupOnboardingFlagsByPerson,
} from "./onboardingFlagAttribution.helpers";

export default function OnboardingFlagsList({
  flags,
  persons,
}: {
  flags: IAcquirerOnboardingFlag[];
  persons?: FlagPersonRef[];
}) {
  const { mode, groups } = groupOnboardingFlagsByPerson(flags, persons ?? []);

  const renderFlags = (items: IAcquirerOnboardingFlag[]) => (
    <List
      bordered
      dataSource={items}
      renderItem={(item) => (
        <List.Item>
          <Typography.Text mark>
            [{getOnboardingFlagTypeLabel(item.type)}]
          </Typography.Text>{" "}
          {item.message}
        </List.Item>
      )}
    />
  );

  if (mode === "flat") {
    return renderFlags(
      groups[0]?.kind === "business" ? groups[0].flags : flags
    );
  }

  return (
    <div>
      {groups.map((group) => (
        <div
          key={group.kind === "person" ? group.personId : "business"}
          style={{ marginBottom: 8 }}
        >
          <Typography.Text strong>
            {group.kind === "person" ? group.name : "Business"}
          </Typography.Text>
          {renderFlags(group.flags)}
        </div>
      ))}
    </div>
  );
}
